document.addEventListener("DOMContentLoaded", function () {

  gsap.registerPlugin(ScrollTrigger);

  // ===== Heading =====
  gsap.from(".main-heading", {
    scale: 0.2,
    opacity: 0,
    duration: 1,
    ease: "power3.out"
  });

  // ===== GENERIC ROW ANIMATION FUNCTION =====
  function animateRow(section, reverse = false) {
    const img = section.querySelector("img");
    const text = section.querySelectorAll("h3, p");

    if (img) {
      gsap.from(img, {
        x: reverse ? 100 : -100,
        opacity: 0,
        duration: 1,
        scrollTrigger: {
          trigger: section,
          start: "top 80%"
        }
      });
    }

    if (text.length) {
      gsap.from(text, {
        x: reverse ? -100 : 100,
        opacity: 0,
        duration: 1,
        stagger: 0.2,
        scrollTrigger: {
          trigger: section,
          start: "top 80%"
        }
      });
    }
  }

  // ===== Apply to Sections =====
  animateRow(document.querySelector(".goldrate-about"), false);
  animateRow(document.querySelector(".goldrate-history"), true);

  // ===== Yellow Cards =====
  gsap.from(".gold-info-card", {
    y: 120,
    opacity: 0,
    duration: 1,
    stagger: 0.25,
    scrollTrigger: {
      trigger: ".gold-left",
      start: "top 85%"
    }
  });

  // ===== Trend Section (split animation like row) =====
  gsap.from(".gold-trend h3, .gold-trend p", {
    x: 50,
    opacity: 0,
    duration: 0.8,
    stagger: 0.2,
    scrollTrigger: {
      trigger: ".gold-trend",
      start: "top 80%"
    }
  });

  gsap.from(".table-box", {
    scale: 0.8,
    opacity: 0,
    duration: 1,
    scrollTrigger: {
      trigger: ".gold-trend",
      start: "top 80%"
    }
  });

  // ===== Green Cards (row-like alternating) =====
  gsap.utils.toArray(".green-card").forEach((card, i) => {
    gsap.from(card, {
      x: i % 2 === 0 ? -120 : 120,
      opacity: 0,
      duration: 1,
      scrollTrigger: {
        trigger: card,
        start: "top 85%"
      }
    });
  });

  // ===== Banner =====
  gsap.from(".top-btn", {
    y: -30,
    opacity: 0,
    duration: 0.8,
    scrollTrigger: {
      trigger: ".gold-banner-section",
      start: "top 90%"
    }
  });

  gsap.from(".banner-img", {
    scale: 1.2,
    opacity: 0,
    duration: 1.2,
    scrollTrigger: {
      trigger: ".banner-container",
      start: "top 85%"
    }
  });

});